export default __webpack_public_path__ + "static/media/star.242a3b5f.svg";